import { Contact, ContactCreateInput, ContactListResponse, ContactResponse, ContactSelectInput, ContactUpdateInput } from '@repo/types';
import { AxiosInstance } from 'axios';
import { axiosInstance } from '../axios-instance';
import { ENDPOINTS } from '../endpoint';
import { BaseApiService } from './base-api.service';

export class ContactService extends BaseApiService {
  constructor(axios: AxiosInstance = axiosInstance) {
    super(ENDPOINTS.CONTACTS.BASE, axios);
  }

  async getContacts(filters: ContactSelectInput): Promise<ContactListResponse> {
    const { page = 1, limit = 10, ...rest } = filters;
    return this.getPaginated<Contact>({ page, limit, ...rest });
  }

  async getContactById(id: number): Promise<ContactResponse> {
    return this.get<ContactResponse>(`/${id}`);
  }

  async createContact(data: ContactCreateInput): Promise<ContactResponse> {
    return this.post<ContactResponse, ContactCreateInput>('', data);
  }

  async updateContact(id: number, data: ContactUpdateInput): Promise<ContactResponse> {
    return this.put<ContactResponse, ContactUpdateInput>(`/${id}`, data);
  }

  async deleteContact(id: number): Promise<ContactResponse> {
    return this.delete<ContactResponse>(`/${id}`);
  }

  async updateContactStatus(id: number, etat: boolean): Promise<ContactResponse> {
    return this.patch<ContactResponse>(`/${id}/status`, { etat });
  }

  async getContactStatistics(startDate?: string, endDate?: string): Promise<any> {
    const params = new URLSearchParams();
    if (startDate) params.append('startDate', startDate);
    if (endDate) params.append('endDate', endDate);

    return this.get<any>(`/statistics${params.toString() ? `?${params.toString()}` : ''}`);
  }

  async getContactOptions(): Promise<Contact[]> {
    return this.get<Contact[]>('/select');
  }
}